import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { ShieldAlert } from "lucide-react";
import { openWhatsApp } from "@/lib/whatsapp";
import { PAGES } from "@/lib/nav";
import { COMPANY, LEGAL_PAGES } from "@/lib/company";

const LOGO = "/tytocare-logo.png";

export default function Footer() {
  return (
    <footer id="footer" className="bg-[#F6F4FA] border-t border-[#5B2C91]/10" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO} alt="TytoCare" className="h-7 w-auto" />
              <span className="rounded-full bg-white px-2.5 py-0.5 text-xs font-semibold text-[#5B2C91]">Italia</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#4A4059]">
              Visite mediche assistite a domicilio. Un infermiere raggiunge la tua casa con TytoCare
              e il medico si collega in diretta.
            </p>
            <motion.button
              onClick={() => openWhatsApp()}
              whileHover={{ y: -2 }}
              className="mt-6 inline-flex items-center gap-2.5 rounded-full bg-[#5B2C91] px-6 py-3.5 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(91,44,145,0.25)] transition-[transform,background-color] duration-200 hover:bg-[#4A2277]"
              data-testid="footer-whatsapp-btn"
            >
              <FaWhatsapp className="h-4 w-4" />
              Richiedi una visita
            </motion.button>
          </div>

          {/* Sitemap */}
          <div className="lg:col-span-7">
            <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-[#8A809A]">Sezioni</h4>
            <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3">
              {PAGES.map((p) => (
                <Link
                  key={p.path}
                  to={p.path}
                  className="text-sm font-medium text-[#4A4059] hover:text-[#5B2C91] transition-colors"
                  data-testid={`footer-link-${p.path.slice(1)}`}
                >
                  {p.label}
                </Link>
              ))}
            </div>
            <p className="mt-8 flex items-start gap-2 text-xs text-[#8A809A]">
              <ShieldAlert className="h-4 w-4 shrink-0 mt-0.5" />
              Servizio dedicato a condizioni non emergenziali. In caso di emergenza contattare il
              112/118.
            </p>
          </div>
        </div>

        <div className="mt-12 border-t border-[#5B2C91]/10 pt-6">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {LEGAL_PAGES.map((p) => (
              <Link
                key={p.path}
                to={p.path}
                className="text-xs font-semibold text-[#4A4059] hover:text-[#5B2C91] transition-colors"
                data-testid={`footer-legal-${p.path.slice(1)}`}
              >
                {p.label}
              </Link>
            ))}
            <Link
              to="/area-riservata"
              className="text-xs font-semibold text-[#4A4059] hover:text-[#5B2C91] transition-colors"
              data-testid="footer-area-riservata"
            >
              Area riservata
            </Link>
          </div>
          <div className="mt-4 flex flex-col gap-2 text-xs text-[#8A809A] sm:flex-row sm:items-center sm:justify-between">
            <span data-testid="footer-company-info">
              © {new Date().getFullYear()} TytoCare Italia · {COMPANY.name} · {COMPANY.address} · P.IVA {COMPANY.vat} · REA {COMPANY.rea}
            </span>
            <span className="shrink-0">Servizio inizialmente disponibile a Roma e provincia.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
